import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Recycle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M180.2 243.1c4.8 20.8-18 37.1-36.1 25.7l-24.3-15.2-50.9 81.43c-13.33 21.32 2.004 48.98 27.15 48.98h32.02c17.64 0 31.98 14.32 31.98 31.96s-14.34 32.05-31.98 32.05H96.15c-75.36 0-121.3-82.84-81.47-146.8l50.83-81.42-24.36-15.3c-18.11-11.4-13.49-39 7.33-43.8l91.43-21.15c8.59-1.85 17.29 3.35 19.29 12.05l21 91.5zM283.1 78.96l41.25 66.14-24.25 15.08c-18.16 11.31-13.57 38.94 7.278 43.77l91.4 21.15c8.622 1.995 17.23-3.387 19.21-12.01l21.04-91.43c4.789-20.81-17.95-37.05-36.07-25.76l-24.36 15.2L337.4 45.14C299.82-15 212.2-15.04 174.6 45.078L167.2 56.9c-9.3 14.85-4.7 34.68 10.1 44 14.92 9.359 34.77 4.886 44.11-10.04l7.442-11.89C241.6 58.58 270.9 59.33 283.1 78.96zM497.3 301.3l-16.99-27.26c-9.336-14.98-29.06-19.56-44.04-10.21-14.94 9.318-19.52 29.15-10.18 44.08l16.99 27.15c13.35 21.32-1.984 49-27.14 49h-95.99l.023-28.74c0-21.38-25.85-32.09-40.97-16.97l-66.41 66.43c-6.222 6.223-6.222 16.41.005 22.63l66.42 66.34c15.12 15.1 40.95 4.386 40.95-16.98l-.024-28.68h95.86C491.2 448.1 537.2 365.2 497.3 301.3z"
  }));
});
Recycle.displayName = 'Recycle';
export var RecycleDimensions = {
  height: 512,
  width: 512
};